// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__HSB4f","container":"footer_container__8ADBa","border":"footer_border__eqaCV","separator":"footer_separator__Fip_b"};